function dateToBrFormat(date, format) {
  if (!date) return '---'

  if (format && format === 'date') return date.toLocaleDateString('pt-BR')
  else
    return date.toLocaleDateString('pt-BR', {
      hour: 'numeric',
      minute: 'numeric'
    })
}

export default dateToBrFormat



// WEBPACK FOOTER //
// ./src/utils/dateToBrFormat.js